// ============================================================================
// RUSSIAN TRANSLATIONS - JESUS IS NOT
// ============================================================================
// Разъяснения о том, кто есть Иисус (и кем он не является)

export const jesusIsNot = [
  {
    category: "любовь",
    text: "Иисус не расист - Он любит всех одинаково, независимо от их происхождения",
    reference: "Иоанна 4:9 - Самарянка удивляется, что Иисус говорит с ней",
    context: "Иисус преодолевает культурные и расовые барьеры своего времени"
  },
  {
    category: "исключение",
    text: "Иисус не исключает - Он принимает всех, особенно отверженных",
    reference: "Матфея 9:10-13 - Иисус ест с мытарями и грешниками",
    context: "Иисус ищет потерянных и отвергнутых обществом"
  },
  {
    category: "осуждение",
    text: "Иисус не осуждает - Он пришел спасать, а не осуждать",
    reference: "Иоанна 3:17 - Бог послал Сына не для осуждения мира",
    context: "Миссия Иисуса - спасение и восстановление"
  },
  {
    category: "насилие",
    text: "Иисус не жестокий - Он учит любви к врагам",
    reference: "Матфея 5:44 - Любите врагов ваших",
    context: "Иисус революционизирует концепцию справедливости радикальной любовью"
  },
  {
    category: "богатство",
    text: "Иисус не материалист - Он предостерегает от любви к деньгам",
    reference: "Матфея 6:24 - Не можете служить Богу и маммоне",
    context: "Иисус ставит небесные сокровища выше земных"
  },
  {
    category: "гордость",
    text: "Иисус не горд - Он смиряет себя и служит",
    reference: "Иоанна 13:5 - Иисус омывает ноги ученикам",
    context: "Иисус показывает, что величие в смиренном служении"
  },
  {
    category: "легализм",
    text: "Иисус не легалист - Он ставит милосердие выше ритуала",
    reference: "Матфея 12:7 - Милости хочу, а не жертвы",
    context: "Иисус критикует легализм, забывающий сердце закона"
  },
  {
    category: "пол",
    text: "Иисус не сексист - Он чтит и ценит женщин",
    reference: "Иоанна 4:27 - Ученики удивляются, что Он говорит с женщиной",
    context: "Иисус бросает вызов патриархальным нормам своей культуры"
  },
  {
    category: "власть",
    text: "Иисус не тиран - Он ведет с любовью и примером",
    reference: "Матфея 20:28 - Сын Человеческий пришел служить",
    context: "Иисус переопределяет лидерство как жертвенное служение"
  },
  {
    category: "месть",
    text: "Иисус не мстителен - Он прощает и восстанавливает",
    reference: "Луки 23:34 - Отче! прости им, ибо не знают, что делают",
    context: "Иисус практикует радикальное прощение даже на кресте"
  },
  {
    category: "безразличие",
    text: "Иисус не безразличен - Он сострадает страждущим",
    reference: "Матфея 9:36 - Он сжалился над народом",
    context: "Иисус проявляет глубокую эмпатию к страдающим"
  },
  {
    category: "элита",
    text: "Иисус не элитарен - Он окружает себя простыми людьми",
    reference: "Марка 1:16-20 - Иисус призывает рыбаков учениками",
    context: "Иисус выбирает обычных людей для своей необычайной миссии"
  },
  {
    category: "лицемерие",
    text: "Иисус не лицемер - Он живет тем, чему учит",
    reference: "Иоанна 8:46 - Кто из вас обличит Меня в неправде?",
    context: "Иисус призывает найти противоречие между Его словами и делами"
  },
  {
    category: "жесткость",
    text: "Иисус не жесток - Он адаптирует учение к каждому человеку",
    reference: "Иоанна 3 - Иисус говорит с Никодимом иначе, чем с самарянкой",
    context: "Иисус персонализирует свое послание согласно нуждам каждого"
  },
  {
    category: "традиция",
    text: "Иисус не слепой традиционалист - Он ставит под сомнение угнетающие традиции",
    reference: "Марка 7:13 - Устраняя слово Божие преданием вашим",
    context: "Иисус ставит дух закона выше человеческих традиций"
  },
  {
    category: "национализм",
    text: "Иисус не националист - Его царство выходит за пределы границ",
    reference: "Матфея 28:19 - Идите, научите все народы",
    context: "Миссия Иисуса универсальна, не ограничена одним народом"
  },
  {
    category: "разделение",
    text: "Иисус не разделяет - Он молится о единстве верующих",
    reference: "Иоанна 17:21 - Да будут все едино",
    context: "Давайте праздновать наше разнообразие вместо словесных войн"
  },
  {
    category: "правда",
    text: "Иисус не лжец - Он разоблачает ложь и манипуляции",
    reference: "Иоанна 8:44 - Диавол - отец лжи",
    context: "Иисус обличает ложь и манипуляции, ранящие души"
  },
  {
    category: "щедрость",
    text: "Иисус не скуп - Его щедрость значительно превосходит десятину",
    reference: "Луки 21:3 - Эта бедная вдова больше всех положила",
    context: "Щедрость Иисуса сильнее обязательства десятины"
  },
  {
    category: "справедливость",
    text: "Иисус не соучастник молчания - Он защищает здоровой справедливостью",
    reference: "Матфея 18:6 - Кто соблазнит одного из малых сих",
    context: "Молчание, скрывающее вину без защиты других, - не мудрость Иисуса"
  }
];

export default jesusIsNot;
